/**
 * 하단 탭 (DESIGN_SPEC 6장 v1.2.1, 시안 03 README 5.13). 상회칠판 · 별채대화 · 나. 높이 64 + 안전 영역.
 *
 * 선택된 탭은 --color-brand, 나머지는 --color-text-secondary. 앱 첫 화면은 별채대화(/).
 * 점(7px --color-star): 상회칠판 = 오늘 안 본 매일 콘텐츠, 별채대화 = 안 본 부르기.
 */
import { NavLink } from 'react-router-dom';
import { BoardIcon, MeIcon, RoomIcon } from './LineIcons.jsx';
import { useNav } from '../stores/nav.js';

const TABS = [
    { to: '/board', label: '상회칠판', Icon: BoardIcon, end: false, dotKey: 'noticeDot' },
    { to: '/', label: '별채대화', Icon: RoomIcon, end: true, dotKey: 'roomDot' },
    { to: '/me', label: '나', Icon: MeIcon, end: false, dotKey: null },
];

export function BottomTabs() {
    // 셀렉터마다 값 하나씩: 객체를 새로 만들어 돌려주면 zustand 가 매번 바뀐 것으로 봅니다
    const noticeDot = useNav((state) => state.noticeDot);
    const roomDot = useNav((state) => state.roomDot);
    const dots = { noticeDot, roomDot };
    return (
        <nav
            aria-label="하단 탭"
            className="grid shrink-0 grid-cols-3 border-t border-hairline bg-surface-tab pb-[env(safe-area-inset-bottom)]"
        >
            {TABS.map(({ to, label, Icon, end, dotKey }) => (
                <NavLink
                    key={to}
                    to={to}
                    end={end}
                    className={({ isActive }) =>
                        `flex h-tab flex-col items-center justify-center gap-1 text-micro ${
                            isActive ? 'text-brand' : 'text-text-secondary'
                        }`
                    }
                >
                    <span className="relative">
                        <Icon size={24} />
                        {dotKey && dots[dotKey] ? (
                            <span
                                aria-hidden="true"
                                className="absolute -top-0.5 -right-1 size-[7px] rounded-full bg-star"
                                style={{ boxShadow: '0 0 0 1.5px var(--color-surface-tab)' }}
                            />
                        ) : null}
                    </span>
                    {label}
                    {dotKey && dots[dotKey] ? <span className="sr-only">새 소식</span> : null}
                </NavLink>
            ))}
        </nav>
    );
}
